import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateRole } from '@services/rbac.service';
import { ROLES_QUERY_KEY } from './useRoles';
import { ROLE_DETAIL_QUERY_KEY } from './useRoleDetail';

export const useUpdateRole = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ roleId, body }) => updateRole(roleId, body),
        onSuccess: (_, { roleId }) => {
            queryClient.invalidateQueries({ queryKey: ROLES_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: ROLE_DETAIL_QUERY_KEY(roleId) });
        },
    });
};
